// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1b991356","578":"b3b5f1e1","977":"1fa8c7fd"}[chunkId] + ".chunk.js";
};